import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation AppUpdateMutation($input: UpdateAppTByAppIdInput!) {
    updateAppTByAppId(input: $input) {
      appT {
        appId
        appStatus
        appName
        appSku
        appUrl
        signupUrl
        appLogo
        description
        appType
        parentAppId
        oemAppId
        atId
        appSkuPrice
        appMarkupAbsolute
        appMarkupPercentage
        paymentOrder
        passThroughFees
        wholesaleDiscountPercentage
        billingFrequency
        showDomain
        showUsername
      }
    }
  }
  `;
    
  function commit(appId, appStatus, appName,
                  appSku, appUrl, signupUrl, appLogo, description, appType,
                  appSkuPrice, appMarkupAbsolute, appMarkupPercentage, paymentOrder, passThroughFees, wholesaleDiscountPercentage, billingFrequency, showDomain, showUsername) {
    var variables = {
        input: {
            appId,
            appTPatch: {}
        }
    };

    if (appName != null)
        variables.input.appTPatch.appName = appName;
    if (appStatus != null)
        variables.input.appTPatch.appStatus = appStatus;
    if (appSku != null)
        variables.input.appTPatch.appSku = appSku;
    if (appUrl != null)
        variables.input.appTPatch.appUrl = appUrl;
    if (signupUrl != null)
        variables.input.appTPatch.signupUrl = signupUrl;
    if (appLogo != null)
        variables.input.appTPatch.appLogo = appLogo;
    if (description != null)
        variables.input.appTPatch.description = description;
    if (appType != null)
        variables.input.appTPatch.appType = appType;
    if (appSkuPrice != null)
    {
        //console.log('trying price ' + appSkuPrice);
        variables.input.appTPatch.appSkuPrice = appSkuPrice;
    }
    if (appMarkupAbsolute != null)
        variables.input.appTPatch.appMarkupAbsolute = appMarkupAbsolute;
    if (appMarkupPercentage != null)
        variables.input.appTPatch.appMarkupPercentage = appMarkupPercentage;
    if (paymentOrder != null)
        variables.input.appTPatch.paymentOrder = paymentOrder;
    if (passThroughFees != null)
        variables.input.appTPatch.passThroughFees = passThroughFees;
    if (wholesaleDiscountPercentage != null)
        variables.input.appTPatch.wholesaleDiscountPercentage = wholesaleDiscountPercentage;
    if (billingFrequency != null)
        variables.input.appTPatch.billingFrequency = billingFrequency;
    if (showDomain != null)
        variables.input.appTPatch.showDomain = showDomain;
    if (showUsername != null)
        variables.input.appTPatch.showUsername = showUsername;
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
        mutation,
        variables,
        updater: (store) => {
          // Mutation store - values that have been updated / returned
          const payload = store.getRootField('updateAppTByAppId');
          const theApp = payload.getLinkedRecord('appT');

          // Retrieved store - assumes that all callers are components that have queried
          // account using 'accountTByAccountId'.
          const theRoot = store.getRoot();
          const preSaveAppId = 'appTByAppId(appId:"' + appId + '")';
          const preSaveApp = theRoot.getLinkedRecord(preSaveAppId);

          // Could restrict to just what has changed, but just do all returned values,
          // which is correct.
          if (preSaveApp != null) {
            preSaveApp.setValue(theApp.getValue('appStatus'),           'appStatus');
            preSaveApp.setValue(theApp.getValue('appName'),             'appName');
            preSaveApp.setValue(theApp.getValue('appSku'),              'appSku');
            preSaveApp.setValue(theApp.getValue('appUrl'),              'appUrl');
            preSaveApp.setValue(theApp.getValue('signupUrl'),           'signupUrl');
            preSaveApp.setValue(theApp.getValue('appLogo'),             'appLogo');
            preSaveApp.setValue(theApp.getValue('description'),         'description');
            preSaveApp.setValue(theApp.getValue('appSkuPrice'),         'appSkuPrice');
            preSaveApp.setValue(theApp.getValue('appMarkupAbsolute'),   'appMarkupAbsolute');
            preSaveApp.setValue(theApp.getValue('appMarkupPercentage'), 'appMarkupPercentage');
            preSaveApp.setValue(theApp.getValue('paymentOrder'),        'paymentOrder');
            preSaveApp.setValue(theApp.getValue('passThroughFees'),     'passThroughFees');
            preSaveApp.setValue(theApp.getValue('state'),               'state');
            preSaveApp.setValue(theApp.getValue('country'),             'country');
            preSaveApp.setValue(theApp.getValue('postalCode'),          'postalCode');
            preSaveApp.setValue(theApp.getValue('wholesaleDiscountPercentage'),   'wholesaleDiscountPercentage');
            preSaveApp.setValue(theApp.getValue('billingFrequency'),   'billingFrequency');
            preSaveApp.setValue(theApp.getValue('showDomain'),         'showDomain');
            preSaveApp.setValue(theApp.getValue('showUsername'),       'showUsername');
          }
        },
        onCompleted: (response) => {
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };